import authService from '../components/api-authorization/AuthorizeService';
import { UserRoles } from '../constants/UserRoles';

export async function isUserAdmin() {
    const user = await authService.getUser();
    return user.hasOwnProperty('role') && (user.role === UserRoles.ADMIN || user.role.indexOf(UserRoles.ADMIN) >= 0);
}

export async function canManageUsers() {
    const isAdmin = await isUserAdmin();
    return isAdmin
}